import { MatDialogConfig } from '@angular/material/dialog';

export enum ModalSize {
    Small = '500px',
    Medium = '750px',
    Large = '1000px',
}

export function getModalConfig(size: ModalSize | null): MatDialogConfig {
    return <MatDialogConfig>{
        autoFocus: false,
        width: size,
        minWidth: ModalSize.Small,
        maxWidth: ModalSize.Large,
        disableClose: true,
    };
}
